# Step 5: Populate your apply form

Populate your apply form with the supplied SEEK Profile information,
and attach the resume file where available.
Keep the following guidance in mind:

- Some details may not be available or may be empty.

  Gracefully handle this scenario and avoid displaying an error message to the candidate.

- If a supplied value fails your form’s validation, avoid truncating or omitting the field.

  Instead, show the supplied value along with suitable error messages, enabling the candidate to make necessary adjustments.

To reduce candidate effort when completing your apply form, endeavour to pre-fill as many matching fields as possible.
At a minimum,
your software must pre-fill the following fields where available and relevant to the apply form:

import { MinimumFieldList } from './minimum-field-list';

<MinimumFieldList />

SEEK Profile information available through Apply with SEEK is only to be used to pre-fill an apply form where a candidate can review and edit the form before submitting.
It must not be used for any other purpose, such as authenticating candidates, creating user accounts, or automatically submitting an application on a candidate’s behalf.
